import { staticBlogPosts } from './blogData';

const API_BASE_URL = 'https://www.vim-garuda.com/api';

export interface BlogPost {
  id?: number;
  slug: string;
  title: string;
  titleId: string;
  excerpt: string;
  excerptId: string;
  content: string;
  contentId: string;
  author: string;
  category: string;
  tags: string[];
  image?: string;
  lang: 'en' | 'zh-TW';
  workFor?: string;
  publishDate?: string;
  date?: string;
}

export async function fetchBlogPosts(workFor: string = 'KYC'): Promise<BlogPost[]> {
  try {
    const response = await fetch(`${API_BASE_URL}/blog/list?workFor=${workFor}`, {
      cache: 'no-store'
    });
    
    if (!response.ok) {
      console.error('API response not ok:', response.status);
      return staticBlogPosts;
    }
    
    const data = await response.json();
    
    if (data.code === 200 && data.data) {
      return data.data;
    }
    return staticBlogPosts;
  } catch (error) {
    console.error('Error fetching blog posts, using static data:', error);
    return staticBlogPosts;
  }
}

export async function fetchBlogPostBySlug(slug: string, workFor: string = 'KYC'): Promise<BlogPost | null> {
  try {
    const response = await fetch(`${API_BASE_URL}/blog/${slug}?workFor=${workFor}`, {
      cache: 'no-store'
    });
    
    if (!response.ok) {
      console.error('API response not ok:', response.status);
      return staticBlogPosts.find((p: BlogPost) => p.slug === slug) || null;
    }
    
    const data = await response.json();
    
    if (data.code === 200 && data.data) {
      return data.data;
    }
    return staticBlogPosts.find((p: BlogPost) => p.slug === slug) || null;
  } catch (error) {
    console.error('Error fetching blog post, using static data:', error);
    return staticBlogPosts.find((p: BlogPost) => p.slug === slug) || null;
  }
}

export async function fetchBlogCategories(workFor: string = 'KYC'): Promise<string[]> {
  try {
    const response = await fetch(`${API_BASE_URL}/blog/categories?workFor=${workFor}`, {
      cache: 'no-store'
    });
    
    if (!response.ok) {
      console.error('API response not ok:', response.status);
      return Array.from(new Set(staticBlogPosts.map((p: BlogPost) => p.category)));
    }
    
    const data = await response.json();
    
    if (data.code === 200 && data.data) {
      return data.data;
    }
    return Array.from(new Set(staticBlogPosts.map((p: BlogPost) => p.category)));
  } catch (error) {
    console.error('Error fetching categories, using static data:', error);
    return Array.from(new Set(staticBlogPosts.map((p: BlogPost) => p.category)));
  }
}
